import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const audiencePoints = ['Tienes 65+ y quieres un control más simple y seguro.', 'Manejas varios medicamentos (diarios o semanales).', 'Te ayudan familiares o cuidadores y quieres que todos estén en la misma página.', 'Quieres evitar confusiones con horarios, dosis o cambios del doctor.'];
export function AudienceSection() {
  return <section className="bg-white py-24 px-6 md:px-12 lg:px-24" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6 text-center md:text-left" data-id="element-13">
            ¿Para quién es Checklist Vital?
          </h2>
        </motion.div>

        <div className="space-y-6 md:space-y-8" data-id="element-14">
          {audiencePoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-6 bg-cream/30 p-6 rounded-2xl" data-id="element-15">
              <CheckCircleIcon className="w-8 h-8 text-sage flex-shrink-0 mt-1" data-id="element-16" />
              <p className="text-xl md:text-2xl text-navy leading-relaxed font-medium" data-id="element-17">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}